import { createFileRoute } from '@tanstack/react-router'
import { useMemo } from 'react'

import { HomeContentContainer } from '@/components'
import { RoleForm } from '@/components/pages/Admin/RoleManagement/Form/RoleForm'
import { useGetRoleById } from '@/modules/role/services/role'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/role/$id/edit')({
  component: RoleEditPage,
})

function RoleEditPage() {
  const t = useTranslations('admin.role_management.edit')
  const { id } = Route.useParams()
  const { data: role } = useGetRoleById(id)

  const roleData = useMemo(() => {
    return {
      name: role?.name,
      description: role?.description,
      permissions: role?.permissions.map((permission) => permission.id),
      maxLogin: role?.max_drivice,
    }
  }, [role])

  return (
    <HomeContentContainer title={t('title')}>
      <RoleForm action="edit" data={roleData as any} id={id} />
    </HomeContentContainer>
  )
}

